import styled from 'styled-components' 
export default styled.div`
.Ram{
    color:blue;
}
 
` 